import styled, { css } from 'styled-components'
import { Colors, Typography } from 'cio-design-library/design-tokens'
import { FontWeights } from 'builder/styles/typography'
import Media from 'builder/styles/media'

export const Container = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;

  ${Media.Phone`
    gap: 4px;
    flex-direction: column;
    align-items: flex-start;
  `}
`

export const NameContainer = styled.div`
  max-width: 193px;
  width: 100%;
`

export const NameText = styled.p<{ $isDisabled?: boolean }>`
  color: ${Colors.Neutral90};
  ${Typography.sizes.Caption};
  ${FontWeights.Regular};

  ${props =>
    props.$isDisabled &&
    css`
      color: ${Colors.Neutral50};
    `}

  ${Media.Phone`
    color: ${Colors.Neutral50};
  `}
`

export const SelectContainer = styled.div`
  flex: 1;
  width: 100%;
`
